import { render, staticRenderFns } from "./CommonFieldText.vue?vue&type=template&id=6350839a&scoped=true"
import script from "./CommonFieldText.vue?vue&type=script&lang=js"
export * from "./CommonFieldText.vue?vue&type=script&lang=js"
import style0 from "./CommonFieldText.vue?vue&type=style&index=0&id=6350839a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6350839a",
  null
  
)

export default component.exports